module.exports = __webpack_public_path__ + "static/media/frog(9).788eda36.PNG";